export default "__VITE_ASSET__D4WVv1TG__"